import "./Card.css";

import useSound from "use-sound";
import soft from "../utils/sounds/soft.mp3";

 function Card(props) {

  const[softSound]  = useSound(soft);

      const link= props.link;
      const github = props.github;
      const tags = props.tags;
      // console.log(props.tags);
 
    return(
    <a className="card" onClick={softSound} href={link}  rel="noreferrer" target='_blank'>
      <div className="hover"></div>
      <img className="card-img" src={props.image}></img>

      <h1 className="cardHead">{props.title}</h1>
      <p className="card-description">{props.content}</p>
      <div className="card-link">
        

          
            <a href={github} target='_blank' id="github-link">Github Link</a>
         
      </div>
      <div className="tagContainer">
      {
    tags.map((elem)=>{
      return(
        <>
        <p className="cardTag">{elem}</p>
        </>
      );
    })
 
 }
      </div>
       
      </a>
    )
;
}

export default Card;
